module.exports = __webpack_public_path__ + "img/c03_buildingtechriteofdamara_Normal_ua.d767d292.webp";